/**
 * Prepare enrollment step: onVisible
 *
 * @param {*} tokena
 * @param {*} user
 * @param {*} stepNum
 * @returns
 */
export async function prepareEnrollmentStep(tokena, user, stepNum) {
  const params = {
    enrollmentToken: tokena,
    user,
    stepNum,
  };

  return fetch('/connect/enrollment/prepare', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      tokena,
    },
    body: JSON.stringify(params),
  }).then((response) => response.json());
}
